export enum MimeType {
  TextPlain = 'text/plain',
  ApplicationJSON = 'application/json',
  ApplicationPDF = 'application/pdf',
  ApplicationMSWord = 'application/msword'
}
